import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { TreeProvider } from './contexts/TreeContext';
import { AppRouter } from './router';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <TreeProvider>
          <div className='App'>
            <AppRouter />
          </div>
        </TreeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
};

export default App;
